import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Dialog } from '@zebra-fed/zds-react-desktop';
import { useTranslation } from "react-i18next";
import { useFormik } from 'formik';
import TextField from "@material-ui/core/TextField";
import { makeStyles } from '@material-ui/core/styles';
import DropdownWithBorders from '../../components/DropdownWithBorders';
import { AuthContext } from '../../authentication/Auth';
import app from '../../authentication/firebaseStart';
import * as firebase from "firebase/app";
import Checkbox from '@material-ui/core/Checkbox';

const PopupContainer = styled.div`
    font-family: 'Roboto';
`
const PopupHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 21px;
    font-weight: 600;
    padding: 10px 0 0 20px;
`
const HeadDes = styled.div`
    padding: 0 0 0 20px;
`
const FooterContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px 10px 0;

    button{
        outline: 0;
        // border: 0;
        padding: 8px 12px;
        font-size: 14px;
        cursor: pointer;
        font-family: 'Roboto';
        transition: all 0.2s;
    }

    button + button{
        margin-left: 12px;
    }
`

const BlueBtn = styled.button`
    color: #fff;
    background: #007ABA;
    border: 2px solid #007ABA;

    &:hover{
        background: #025681;
        border-color: #025681;
    }
`
const TransBtn = styled.button`
    color: #3b3d46;
    background: #fff;
    border: 2px solid #3b3d46;
    font-weight: 500;

    &:hover{
        background: #e0dddd;
        border-color: #e0dddd;
    }
`
const BodyContent = styled.div`
    display: flex;
    justify-content: center;
    padding: 15px 20px 40px 20px;

`
const Formcontainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 10px;
`

const StyledTextField = styled(TextField)`
  display: flex;
  width: 100%;

  input{
  padding: 9px !important;

      &:focus{
        border-color:#2684FF !important;
    }
  }

  & .MuiOutlinedInput-root {
      &.Mui-focused fieldset {
        border-color: #2684FF !important;
      }
    }

`;

const LabelText = styled.label`
    color: #4f4f4f;
    font-size: 15px;
`

const ErrorLine = styled.p`
    font-size: 0.75rem;
    margin-top: 3px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    margin-left: 14px;
    color: #f44336;
`
const CheckBoxRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 0 0 -10px;
`

const useStyles = makeStyles((theme) => ({
    dropdown: {
        minWidth: '420px'
    },
}));

export default function ModifyDevicesPopUp(props) {
    const classs = useStyles();
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const context = useContext(AuthContext);
    const companyID = context.currentUser.claims.companyID;
    const firestore = app.firestore();
    const [siteData, setsiteData] = useState([])
    const [siteIsLoading, setIsLoading] = useState(false)
    const [IsUpdating, setIsUpdating] = useState(false)
    const [dataValue, setdataValue] = useState('')
    const [dataError, setdataError] = useState(false)
    const [dataErrorTxt, setdataErrorTxt] = useState(false)
    const [checkAll, setcheckAll] = useState(false)


    const getSelectInputSearch = async (rawInput, type) => {
        try {

            let Query = firestore
                .collection('tenants')
                .doc(companyID)
                .collection('SiteLocations')
                .orderBy('siteName');

            let proceed = false;

            if (type == 'ENTERHIT') {
                Query = Query.startAt(rawInput.toUpperCase()).endAt(rawInput.toUpperCase() + "\uf8ff")
                proceed = true;
            } else if (type == 'INIT') { proceed = true; }

            if (proceed) {
                let sites = [];
                setIsLoading(true);
                sites = (await Query.limit(10).get()).docs.map((doc) => doc.data());
                let finalSitesArray = [];
                if (sites.length > 0) {
                    sites.forEach(ele => {
                        finalSitesArray.push({ label: ele.siteName, value: ele.siteName, displayName: ele.displaySiteName })
                    });
                }
                setsiteData(finalSitesArray)
                setIsLoading(false);
            }
        } catch (err) { console.log(err, 'wewe') }
    }

    useEffect(() => { getSelectInputSearch('', 'INIT') }, []);

    useEffect(() => {
        const updateData = !!props?.PopupData?.updateData ? props.PopupData.updateData[0] : null;
        if(props.PopupData.edit === 'edit_site' && updateData){
            let selectedSite = { displayName: updateData.displaySiteName, label: updateData.displaySiteName, value: updateData.siteName }
            setdataValue(selectedSite);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.PopupData.updateData]);

    const validateTxtField = (dataValuee) => {

        const scope = props.PopupData.edit
        setdataError(true);
        if (!dataValuee.trim()) {
            setdataErrorTxt(
                scope == 'edit_device' ? t('validation.rules.Mo_Dash.EmptyDeviceName')
                    :
                    scope == 'edit_aps' ? t('validation.rules.Mo_Dash.EmptyAPS') : ''
            );
            return false
        } else if (dataValuee.length > 32) {
            setdataErrorTxt(
                scope == 'edit_device' ? t('validation.rules.Mo_Dash.DeFrNa32Len')
                    :
                    scope == 'edit_aps' ? t('validation.rules.Mo_Dash.APSNa32Len') : ''
            );
            return false
        }
        setdataError(false);
        return true
    }

    const onConfirmClicked = async () => {
        setdataError(true)
        if (props.PopupData.edit == 'edit_site') {
            if (dataValue) {
                setdataError(false)
                if (checkAll) { updateSite_AllRecord() }
                else { update_SelectedRecord() }
            } else { setdataError(true); }
        }
        else {
            if (!validateTxtField(dataValue)) return;
            update_SelectedRecord();
        }
    }

    const update_SelectedRecord = async () => {
        try {
            setIsUpdating(true)
            let batch = firestore.batch();
            props.PopupData.updateData.forEach(_element => {


                let element = {}

                for (let key in _element) {

                    if (key != 'checked' && key != 'tableData') {
                        element[key] = _element[key] == undefined ? null : _element[key];
                    }
                }

                console.log(element, 'element')
                const docRef = firestore.collection("tenants")
                    .doc(companyID)
                    .collection('Devices')
                    .doc(element.modelNumber + '_' + element.serialNumber);

                batch.update(docRef, {
                    // ...element,

                    lastUpdatedAt: Date.now(),

                    displaySiteName: props.PopupData.edit == 'edit_site' ?
                        dataValue.displayName : (element.displaySiteName ? element.displaySiteName : ''),
                    siteName: props.PopupData.edit == 'edit_site' ?
                        dataValue.value : (element.siteName ? element.siteName : ''),

                    displayDeviceFriendlyName: props.PopupData.edit == 'edit_device' ?
                        dataValue : (element.displayDeviceFriendlyName ? element.displayDeviceFriendlyName : ''),
                    friendlyName: props.PopupData.edit == 'edit_device' ?
                        dataValue.toUpperCase() : (element.friendlyName ? element.friendlyName : ''),

                    apFriendlyName: props.PopupData.edit == 'edit_aps' ?
                        dataValue : (element?.apFriendlyName ? element.apFriendlyName : ''),
                })

                if (props.PopupData.edit == 'edit_site' || props.PopupData.edit == 'edit_device') {

                    const Moniter_docRef = firestore.collection("tenants")
                        .doc(companyID)
                        .collection('Devices')
                        .doc(element.modelNumber + '_' + element.serialNumber)
                        .collection("Monitor")
                        .doc('Assignment');

                    batch.set(Moniter_docRef, {

                        displaySiteName: props.PopupData.edit == 'edit_site' ?
                            dataValue.displayName : (element.displaySiteName ? element.displaySiteName : ''),
                        siteName: props.PopupData.edit == 'edit_site' ?
                            dataValue.value : (element.siteName ? element.siteName : ''),

                        displayDeviceFriendlyName: props.PopupData.edit == 'edit_device' ?
                            dataValue : (element.displayDeviceFriendlyName ? element.displayDeviceFriendlyName : ''),
                        friendlyName: props.PopupData.edit == 'edit_device' ?
                            dataValue.toUpperCase() : (element.friendlyName ? element.friendlyName : ''),

                    })
                }
            });

            await batch.commit();
            onClose(true)
            setTimeout(() => {
                let data = props.PopupData.updateData.length
                props.popUpTrigger({
                    from: 'modify',
                    msg: { show: true, error: false, data: t("Mo_Dash.placeholders.DevicesUpdatedSuccessfully",{data}) },
                    // needToLoad: true,
                    // close: true
                })
            }, 1000);

        } catch (e) {
            console.log(e)
            setIsUpdating(false)
            setTimeout(() => {
                props.popUpTrigger({
                    from: 'delete',
                    msg: { show: true, error: true, data: t("Mo_Dash.placeholders.DeletingDevices") },
                    needToLoad: false
                })
            }, 1000);
        }
    }

    const updateSite_AllRecord = () => {
        try {
            setIsUpdating(true)
       
            const updateAll_WO_Filter = async (lastReported) => {

                let batch = firestore.batch();

                let Query =
                    firestore.collection("tenants")
                        .doc(companyID)
                        .collection('Devices')
                        .orderBy('reportedAt', 'desc')

                if (lastReported != null) { Query = Query.startAfter(lastReported) }

                const snapshot = (await Query.limit(100).get())

                const batchSize = snapshot.size;

                if (batchSize === 0) {
                    onClose(true);
                    setTimeout(() => {
                        props.popUpTrigger({
                            from: 'modify',
                            msg: { show: true, error: false, data: t("Mo_Dash.placeholders.AllDevicesUpdatedSuccessfully") },
                            // needToLoad: true,
                            // close: true
                        })
                    }, 1000);

                    return
                } else {

                    let snapshotData = snapshot.docs.map((doc) => doc.data());

                    lastReported = snapshotData[snapshotData.length - 1]?.reportedAt;

                    // let firebaseTimeStamp = firebase.firestore.FieldValue.serverTimestamp()

                    snapshot.docs.forEach((doc) => {

                        let docData = doc.data()

                        const Moniter_docRef = firestore.collection("tenants")
                            .doc(companyID)
                            .collection('Devices')
                            .doc(docData.modelNumber + '_' + docData.serialNumber)
                            .collection("Monitor")
                            .doc('Assignment');

                        batch.set(doc.ref, {
                            ...doc.data(),
                            lastUpdatedAt: Date.now(),
                            displaySiteName: dataValue.displayName,
                            siteName: dataValue.value
                        });

                        batch.set(Moniter_docRef, {
                            displayDeviceFriendlyName: docData?.displayDeviceFriendlyName ? docData?.displayDeviceFriendlyName : '',
                            friendlyName: docData?.friendlyName ? docData?.friendlyName : '',
                            displaySiteName: dataValue.displayName,
                            siteName: dataValue.value
                        })
                    });
                    await batch.commit();
                    updateAll_WO_Filter(lastReported)
                }
            }



            const updateAll_By_Filter = async (lastReported) => {

                console.log('camamamamamama')
                setIsLoading(true)

                const getQuery = (lastReported) => {
                    console.log(lastReported, 'lastReported')
                    const FD = props.PopupData.filterData;

                    let query = firestore.collection("tenants")
                        .doc(companyID)
                        .collection('Devices')


                    // if (lastReported != null) { query = query.where('reportedAt', '<', lastReported) }

                    if (FD.site != null) {
                        query = query.where("siteName", "==", FD.site ? FD.site.toUpperCase() : '')
                    }

                    //state
                    if (FD.state &&
                        FD.state != "totalTracked" &&
                        FD.state != "lowBattery") {
                        query = query.where(FD.title_key, "==", FD.title_value);
                    }

                    if (FD.state === "lowBattery") {
                        FD.title_lowBatteryArr.forEach((items) => {
                            query = query.where(items._key, "==", items._value);
                        });
                    }


                    if (FD.searchString && FD.opt) {
                        query = query.orderBy(FD.opt).orderBy('reportedAt', 'desc')
                            .startAt(FD.searchString).endAt(FD.searchString + "\uf8ff")
                    } else {
                        query = query.orderBy('reportedAt', 'desc')
                    }
                    return query
                }

                let batch = firestore.batch();

                const snapshot = await getQuery(lastReported).limit(10000).get();
                let iteration = 0
                // let firebaseTimeStamp = firebase.firestore.FieldValue.serverTimestamp()

                snapshot.docs.forEach(async (doc) => {
                    if (iteration == 250) {
                        iteration = 0;
                        await batch.commit();
                        batch = firestore.batch();
                        // firebaseTimeStamp = firebase.firestore.FieldValue.serverTimestamp()
                    }
                    iteration += 1
                    let docData = doc.data()
                    console.log(docData, 'doc.data()')

                    const Moniter_docRef = firestore.collection("tenants")
                        .doc(companyID)
                        .collection('Devices')
                        .doc(docData.modelNumber + '_' + docData.serialNumber)
                        .collection("Monitor")
                        .doc('Assignment');

                    batch.set(doc.ref, {
                        ...doc.data(),
                        lastUpdatedAt: Date.now(),
                        displaySiteName: dataValue.displayName,
                        siteName: dataValue.value
                    });

                    batch.set(Moniter_docRef, {
                        displayDeviceFriendlyName: docData.displayDeviceFriendlyName,
                        friendlyName: docData.friendlyName,
                        displaySiteName: dataValue.displayName,
                        siteName: dataValue.value
                    })
                })

                await batch.commit();

                onClose(true);
                setTimeout(() => {
                    let data = snapshot.size
                    props.popUpTrigger({
                        from: 'modify',
                        msg: { show: true, error: false, data: t("Mo_Dash.placeholders.DevicesUpdatedSuccessfully",{data})  },
                        needToLoad: true
                    })
                }, 1000);


                // if (batchSize === 0) {
                //     onClose(true);
                //     setTimeout(() => {
                //         props.popUpTrigger({
                //             from: 'modify',
                //             msg: { show: true, error: false, data: t("Mo_Dash.placeholders.AllDevicesUpdatedSuccessfully") },
                //             needToLoad: true
                //         })
                //     }, 1000);

                //     return
                // } else {
                //     const snapshotDocs = snapshot.docs

                //     const lastReported = snapshotDocs[snapshotDocs.length - 1].data().reportedAt

                //     console.log('reportedAt', lastReported)

                //     snapshotDocs.forEach((doc) => {
                //         console.log(doc.data(), 'doc.data()')
                //     })
                //     snapshotDocs.forEach((doc) => {

                //         let docData = doc.data()

                //         const Moniter_docRef = firestore.collection("tenants")
                //             .doc(companyID)
                //             .collection('Devices')
                //             .doc(docData.modelNumber + '_' + docData.serialNumber)
                //             .collection("Monitor")
                //             .doc('Assignment');

                //         batch.set(doc.ref, {
                //             ...doc.data(),
                //             lastUpdatedAt: firebase.firestore.FieldValue.serverTimestamp(),
                //             displaySiteName: dataValue.displayName,
                //             siteName: dataValue.value
                //         });

                //         batch.set(Moniter_docRef, {
                //             displayDeviceFriendlyName: docData.displayDeviceFriendlyName,
                //             friendlyName: docData.friendlyName,
                //             displaySiteName: dataValue.displayName,
                //             siteName: dataValue.value
                //         })



                //     });
                //     await batch.commit();
                //     updateAll_By_Filter(lastReported)
                // }
            }

            let filterData = props.PopupData.filterData

            console.log(filterData, 'dsdsdsd')
            if (filterData.site != null ||
                filterData.state != 'totalTracked' ||
                filterData.searchString != '' ||
                filterData.opt != '') {
                updateAll_By_Filter(null);
            }
            else {
                updateAll_WO_Filter(null);
            }

        } catch (e) {
            console.log(e, 'esewewe')
            setIsUpdating(false)
            setTimeout(() => {
                props.popUpTrigger({
                    from: 'delete',
                    msg: { show: true, error: true, data: t("Mo_Dash.placeholders.DeletingDevices") },
                    needToLoad: false
                })
            }, 1000);
        }
    }

    const onClose = (e = false) => {
        setIsLoading(false);
        setIsUpdating(false);
        setdataValue('');
        setdataError(false);
        setcheckAll(false);
        props.popUpTrigger({ from: 'modify', close: true, needToLoad: e })
    }

    return (
        <Dialog
            ref={dialogRef}
            key='dialog2'
            width='520px'
            headerStyle={{ display: 'none' }}
            bodyStyle={{ padding: '0px', width: '100%' }}
            cardStyle={{ minWidth: '100px !important', padding: '10px' }}
            footerStyle={{ display: 'none' }}>

            <PopupContainer>
                <PopupHeader>{t('Mo_Dash.placeholders.mofify')}</PopupHeader>
                <HeadDes>{t('manual')}</HeadDes>

                <BodyContent>
                    <div style={{ pointerEvents: IsUpdating ? 'none' : '', width: '100%' }}>

                        {props.PopupData.edit != 'edit_site' ? <Formcontainer>
                            <LabelText>
                                {
                                    props.PopupData.edit == 'edit_device' ?
                                        t('Mo_Dash.placeholders.devicename')
                                        :
                                        props.PopupData.edit == 'edit_aps' ?
                                            t('Mo_Dash.placeholders.aps') : ''
                                }
                            </LabelText>
                            <StyledTextField
                                id='outlined-basic'
                                variant="outlined"
                                error={dataError}
                                onChange={e => { setdataValue(e.target.value); validateTxtField(e.target.value) }}
                                value={dataValue}
                                helperText={
                                    dataError ? (dataErrorTxt) : null
                                }
                                placeholder={
                                    props.PopupData.edit == 'edit_device' ?
                                        t('Mo_Dash.placeholders.EnterDevicename')
                                        :
                                        props.PopupData.edit == 'edit_aps' ?
                                            t('Mo_Dash.placeholders.enter_aps') : ''
                                }
                            />
                        </Formcontainer> : null}

                        {props.PopupData.edit == 'edit_site' ? <Formcontainer>
                            <LabelText>{t('Mo_Dash.placeholders.sitename')}</LabelText>
                            <DropdownWithBorders
                                selectOpts={siteData}
                                onChange={(e) => { setdataValue(e); setdataError(false) }}
                                resetSelect={false}
                                selectVal={dataValue}
                                isSearchable={true}
                                onSearchInpChange={getSelectInputSearch}
                                customFilterOption={() => { return siteData }}
                                selectOnBlur={() => { }}
                                error={dataError}
                                isLoading={siteIsLoading}
                            />
                            <ErrorLine style={{ display: dataError ? 'block' : 'none' }}>
                                {t('validation.rules.Mo_Dash.SiteNotSelected')}
                            </ErrorLine>
                        </Formcontainer> : null}

                        {props.PopupData.needcheck ? <CheckBoxRow>
                            <Checkbox
                                checked={checkAll ? checkAll : false}
                                color="primary"
                                onClick={e => { setcheckAll(!checkAll) }}
                                name="deviceRow" />
                            <p>{props.PopupData.checktext}</p>
                        </CheckBoxRow> : null}
                    </div>

                </BodyContent>

                <FooterContainer style={{ pointerEvents: IsUpdating ? 'none' : '' }}>
                    <TransBtn onClick={() => { onClose(false) }}>{t('cancel')}</TransBtn>
                    <BlueBtn onClick={onConfirmClicked}>{IsUpdating ? t('workingOnIt') : t('Confirm')}</BlueBtn>
                </FooterContainer>

            </PopupContainer>

        </Dialog>
    )
}





